<template>
  <div class="goods">
    <van-nav-bar
      :title="titleName"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      class="nav_title"
      />
    <!-- <van-image :src="goods.pic" class="header_img"></van-image> -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item_head,index_head) in goods.imgs.split(',')" :key="index_head">
        <van-image :src="item_head" class="header_img"></van-image>
      </van-swipe-item>
    </van-swipe>

    <van-cell-group>
      <van-cell :border="false">
        <div class="goods-price">
            {{$t('Pay.money')}}{{ formatPrice(goods.price) }}
            <!-- <span class="source">原價:{{ formatPrice(goods.oriPrice) }}</span> -->
        </div>
        <div class="goods-brief">{{goods.brief}}</div>
        <div class="goods-title">{{ goods.prodName}}</div>
        

      </van-cell>
      <van-cell class="goods-express">
        <div class="sku_line_item">
          <span class="color">{{$t('detail.carriage')}}：{{ getTransName(goods.transport)}}</span>
          <span  class="color">{{$t('detail.surplus')}}：{{ goods.totalStocks }}</span>
        </div>
      </van-cell>
      <van-cell class="border">
        <div class="sku_line_item">
          <span style="flex:1">保障:</span>
          <span>正品保障  假壹賠四   極速退款</span>
        </div>
      </van-cell>
      <van-cell class="border">
        <div class="sku_line_item">
          <span style="flex:1">已選：{{selectedSku.name}}</span>
          <span style="margin-right:24px;">數量：{{selectedNum}}</span>
           <van-stepper v-model="selectedNum" />
        </div>
        <!-- <van-icon slot="right-icon" name="ellipsis" style="line-height: inherit;" /> -->
      </van-cell>
    </van-cell-group>

    <div style="background: #f8f8f8;">
      <van-divider :style="{ color: '#7c7d7d', padding: '8px 16px', margin:'0px'}">{{$t('detail.goods_detail')}}</van-divider>
    </div>

    <div :style="{width:'100%',overflow: 'hidden'}" v-html="goods.content"></div>
    <div style="margin-top:0.4rem" v-for="thumb in goods.thumb" :key="thumb">
      <van-image :style="{width:'100%'}" fit="none" :src="thumb" />
    </div>
    <van-goods-action>
      <van-goods-action-icon icon="wap-home" @click="home">首頁</van-goods-action-icon>
      <van-goods-action-icon
        icon="cart-o"
        @click="onClickCart"
        :info="count ==0?'':count"
      >{{$t('detail.cart')}}</van-goods-action-icon>
      <van-goods-action-button type="warning" @click="addCart">{{$t('detail.add_cart')}}</van-goods-action-button>
      <van-goods-action-button type="danger" @click="addCart">{{$t('detail.buy_now')}}</van-goods-action-button>
    </van-goods-action>

    <van-sku
      v-model="show"
      :sku="sku"
      :goods="skuGoods"
      :buy-text="$t('detail.buy_now')"
      :add-cart-text="$t('detail.add_cart')"
      @buy-clicked="onBuyClicked"
      @add-cart="onAddCartClicked"
      @stepper-change="stepperChange"
      @sku-selected="skuSelected"
    />

    <!--购物车弹框-->
    <van-action-sheet v-model="cartShow" title="選擇商品規格" class="sheet">
        <van-row class="title">
          <div class="name"><span>{{goods.prodName}}</span></div>
          <div>
            <span class="money">{{$t('Pay.money')}}{{ formatPrice(goods.price) }}</span>
            <!-- <span class="orign">{{ formatPrice(goods.oriPrice) }}</span> -->
          </div>
        </van-row>
        <div class="cont">
              <div class="combo"> 
            <van-row class="goodSheet" type="flex">
              <van-col style="width: 55%;">
                <van-image
                  width="180"
                  height="180"
                  fit="scale-down"
                  :src="selectedImg"
                  />
              </van-col>
              <van-col class="skuName">
                  <div class="name">
                    <span v-for="(item,index) in selSkuName" :key="index">
                          {{item}}
                    </span>
                      {{selectedImgText}}
                  </div>
              </van-col>
            </van-row>
          <van-row  v-for="(itemp,indexp) in goods.prodProps" :key="indexp">
            <!-- <van-row v-if="imageUrlStatus(itemp.prodPropValues)">
              <van-cell-group :border="false">
                  <van-cell :border="false">
                    <div class="sku_line_item">
                      <span style="flex:1">{{itemp.propName}}</span>
                    </div>
                  </van-cell>
                </van-cell-group>
                <van-row class="grid"  type="flex" style=" flex-wrap:wrap" >
                <van-col 
                  class="grid_item"  
                  v-for="(items,indexs) in itemp.prodPropValues" 
                  :class="[selectSkuList[indexp]==indexs?'select':'']" 
                  :key="indexs"
                  @click="toSelectSkuImage(indexp,indexs)"
                >
                    <van-image class="van_img" :src="items.imageUrl" />
                </van-col>
              </van-row>
            </van-row>
              
              <van-row v-else> -->
              <van-row>
                <van-cell-group :border="false">
                  <van-cell :border="false">
                    <div class="sku_line_item">
                      <span style="flex:1">{{itemp.propName}}</span>
                    </div>
                  </van-cell>
                </van-cell-group>
                <van-tag 
                  v-for="(itemm,indexx) in itemp.prodPropValues" 
                  plain
                  :key="itemm.valueId" 
                  :type="selectSkuList[indexp]==indexx?'danger':'primary'" 
                  :color="selectSkuList[indexp]==indexx?'': '#dcdfe6'" 
                  :text-color="selectSkuList[indexp]==indexx?'': '#94979c'"
                  class="tag"
                  @click="toSelectSkuName(indexp,indexx)"
                >{{itemm.propValue}}</van-tag>
              </van-row>
              
            </van-row>
         
          </div>

        </div>
        
      <van-goods-action style="z-index:99">
        <van-goods-action-button type="warning" @click="addCartClicked">{{$t('detail.add_cart')}}</van-goods-action-button>
        <van-goods-action-button type="danger" text="立即購買" @click="buyClicked" />
      </van-goods-action>
    
    </van-action-sheet>



  </div>
</template>

<script>
import { Toast,ActionSheet, GoodsAction, GoodsActionIcon, GoodsActionButton,NavBar} from 'vant';
import { mapMutations, mapState } from 'vuex';
import { findIndex, remove, cloneDeep } from 'lodash';
import goods from '@/api/goods';
import { moneys } from "../../static/moneyString"
export default {
  data() {
    return {
      moneysString:'',
      sku: {
        tree: [],
        list: [],
        price: '11', // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无規格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无規格商品
        hide_stock: false, // 是否隐藏剩余库存
      },
      show: false,
      cartShow:false,
      goods: {
        transport: {},
        skuList: [{}],
      },
      skuGoods: {},
      selectedSku: {},
      selectedNum: 0,
      selectSkuIndex:0, //选中的規格
      selectedImg:'',  //选中的规格颜色中的图片
      selectedImgText:'',//选中的规格颜色中文字
      selectSkuList:[],  //选中的规格的数组
      selSkuName:[], //选中的规格的名字
      skuIndexList:[],//选中的规格的vaiueId
      skuList:[], //后端传递的skuList
      skuId:0,
    };
  },
  computed: {
    count: {
      get() {
        let cartGoods = this.$store.state.goods.shopCardGoods;
        let count = cartGoods.reduce((total, item) => total + item.num, 0);
        return count;
      },
    },
  },
  created() {
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
    let shopIds = sessionStorage.getItem("shopId") || this.$store.state.user.regionData.shopId;
    this.$Fbq.getFbqId('cart',shopIds)
    this.titleName = this.$store.state.designer.titleName;
    let param1 = this.$route.params || {};
    let param = {
      prodId:param1.prodId
    }
    // console.log('param',param1)
    if(param1.type=='tag'){  //商品分组标签
       goods.tagProdInfo(param).then((res) => {
        // console.log('====res=====', res);
        let thumb = res.imgs.split(',');
        this.goods = res;
        this.goods['thumb'] = thumb;
        this.skuGoods['title'] = this.goods.prodName;
        this.skuGoods['picture'] = this.goods.pic;
        this.skuList = res.skuList
        // res.skuList[0].pic = this.goods.pic;
        // res.skuList[0].skuName = '红色，中码 iphone11';
        // let sku = Object.assign({}, res.skuList[0]);
        // sku.skuId = '1234';
        // sku.skuName = '红色，大码 iphoneX';
        // res.skuList.push(sku);
        // res.skuList.push(Object.assign({}, res.skuList[0]));
        // res.skuList.push(Object.assign({}, res.skuList[0]));
        this.goods.prodProps.forEach((item,index)=>{
          this.selectSkuList.push(0) //默认第一个规格选中
          if(item.prodPropValues[0].imageUrl){
            this.selectedImg  = item.prodPropValues[0].imageUrl;
            this.selectedImgText  = item.prodPropValues[0].propValue;
          }else{
            this.selSkuName[index]=item.prodPropValues[0].propValue;
          }
          this.skuIndexList[index]=item.prodPropValues[0].valueId;
        })
        this.getSkuList()
        // this.convertSku(res.skuList);
        // this.selectedImg = res.skuList[0].pic
      });
    }else{
      goods.goodsInfo(param.prodId).then((res) => {
        // console.log('====res=====', res);
        let thumb = res.imgs.split(',');
        this.goods = res;
        this.goods['thumb'] = thumb;
        this.skuGoods['title'] = this.goods.prodName;
        this.skuGoods['picture'] = this.goods.pic;
        this.skuList = res.skuList
        // res.skuList[0].pic = this.goods.pic;
        // res.skuList[0].skuName = '红色，中码 iphone11';
        // let sku = Object.assign({}, res.skuList[0]);
        // sku.skuId = '1234';
        // sku.skuName = '红色，大码 iphoneX';
        // res.skuList.push(sku);
        // res.skuList.push(Object.assign({}, res.skuList[0]));
        // res.skuList.push(Object.assign({}, res.skuList[0]));
        this.goods.prodProps.forEach((item,index)=>{
          this.selectSkuList.push(0) //默认第一个规格选中
          if(item.prodPropValues[0].imageUrl){
            this.selectedImg  = item.prodPropValues[0].imageUrl;
            this.selectedImgText  = item.prodPropValues[0].propValue;
          }else{
            this.selSkuName[index]=item.prodPropValues[0].propValue;
          }
          this.skuIndexList[index]=item.prodPropValues[0].valueId;
        })
        this.getSkuList()
        // this.convertSku(res.skuList);
        // this.selectedImg = res.skuList[0].pic
      });
    }
    
  },
  methods: {
    imageUrlStatus(prodPropValues){  //判断规格中是否有图片
      let status = false
      prodPropValues.forEach((item,index)=>{
        if(item.imageUrl){
         status =  true
        }
      })
      return status
    },
    //选择规格中的颜色--显示图片
    toSelectSkuImage(indexp,indexs){  //indexp:prodPropValues数组的第indexp个;indexs：对应颜色中规格中的第indexs个
      let val =  this.goods.prodProps[indexp].prodPropValues[indexs];
      this.selectedImgText = val.propValue;
      this.selectSkuList[indexp]=indexs
       this.skuIndexList[indexp]=val.valueId; //选中的规格的valueId
      this.getSkuList()

    },
    onClickLeft(){
      this.$router.go(-1)
    },
    toSelectSkuName(indexp,indexs){   //选着规格
      let val =  this.goods.prodProps[indexp].prodPropValues[indexs];  //获取到对应的规格的详情
      this.selSkuName[indexp]=val.propValue
      this.selectSkuList[indexp]=indexs
      //深拷贝
      let selSkuName =cloneDeep(this.selSkuName);
      let selectSkuList =cloneDeep(this.selectSkuList);
      this.selectSkuList = selectSkuList
      this.selSkuName = selSkuName

      this.skuIndexList[indexp]=val.valueId; //选中的规格的valueId
      this.getSkuList()

    },
    getSkuList(){  //获取到skuList中的skuId
      let propertiesId='';
      this.skuIndexList.forEach((item,index)=>{
        propertiesId= propertiesId+item+','
      })
      propertiesId=(propertiesId.substring(propertiesId.length-1)==',')?propertiesId.substring(0,propertiesId.length-1):propertiesId;  //去除最后一个逗号
      this.skuList.forEach((item,index)=>{
        if(item.propertiesId==propertiesId){
          this.skuId = item.skuId
          this.selectedImg  = item.pic;
        }
      })
    },
    home() {
      this.$router.replace('/');
    },
    convertSku(skuList) {
      let v = [];
      let list = [];
      skuList.forEach((item, index, array) => {
        let vItem = {
          id: item.skuId,
          name: item.skuName,
          imgUrl: item.pic,
        };
        v.push(vItem);
        let listItem = {
          id: item.skuId, // skuId，下单时后端需要
          price: item.price * 100, // 价格（单位分）
          brief: item.brief , // 价格（单位分）
          sku_id: item.skuId, // 規格类目 k_s 为 s1 的对应規格值 id
          stock_num: item.stocks, // 当前 sku 组合对应的库存
        };
        list.push(listItem);
      });
      this.sku = {
        tree: [{ k: '規格', k_s: 'sku_id', v }],
        list,
        price: this.goods.price,
        stock_num: this.goods.totalStocks, // 商品总库存
      };
    },
    ...mapMutations('goods', {
      addShopCardGoods: 'addShopCardGoods',
      refreshOrderGoods: 'refreshOrderGoods',
    }),
    formatPrice(price) {
      return  + price;
    },
    getTransName(transport) {
      if (transport != undefined && transport != '') {
        return transport.transName;
      }
      return '';
    },
    onClickCart() {
      this.$router.push('/cart');
    },
    onBuyClicked(e) {
      if (e.selectedSkuComb == null) {
        Toast('請選擇一种規格');
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = e.selectedSkuComb.sku_id;
      buyGoods.selectedSkuName = this.getSkuName(e.selectedSkuComb.sku_id);
      buyGoods.selectedSkuPrice = this.getSkuPrice(e.selectedSkuComb.sku_id);
      buyGoods['num'] = e.selectedNum;
      let goodsList = [buyGoods];
      this.refreshOrderGoods(goodsList);
      this.$router.push('/orderStep3');
      this.show = false;
    },
     buyClicked() {
      // if (e.selectedSkuComb == null) {
      //   Toast('請選擇一种規格');
      //   return;
      // }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = this.skuId;
      buyGoods.selectedSkuName = this.getSkuName(this.skuId);
      buyGoods.selectedSkuPrice = this.getSkuPrice(this.skuId);
      buyGoods['num'] =this.selectedNum;
      let goodsList = [buyGoods];
      this.refreshOrderGoods(goodsList);
      this.$router.push('/orderStep3');
      this.show = false;
    },
    onAddCartClicked(e) {
      if (e.selectedSkuComb == null) {
        Toast('請選擇一种規格');

        return;
      }
      this.show = false;
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = e.selectedSkuComb.sku_id;
      buyGoods.selectedSkuName = this.getSkuName(e.selectedSkuComb.sku_id);
      buyGoods.selectedSkuPrice = this.getSkuPrice(e.selectedSkuComb.sku_id);
      buyGoods['num'] = this.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t('tips.cart_success'));
    },
    addCartClicked() {
      // console.log('=====fbq=====',fbq)
      fbq('track', 'AddToCart');
      this.show = false;
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = this.skuId;
      buyGoods.selectedSkuName = this.getSkuName(this.skuId);
      buyGoods.selectedSkuPrice = this.getSkuPrice(this.skuId);
      buyGoods['num'] = this.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t('tips.cart_success'));
    },

    getSkuName(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].skuName;
        }
      }
    },
    getSkuPrice(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].price;
        }
      }
    },
    addCart() {
      // if (this.selectedSku.id == undefined || this.selectedSku.id == null) {
      //   // Toast('請選擇一种規格');
      //   this.show = true;
      //   return;
      // }
      this.cartShow = true
      // let buyGoods = cloneDeep(this.goods);
      // buyGoods.selectedSkuId = this.selectedSku.id;
      // buyGoods.selectedSkuName = this.selectedSku.name;
      // buyGoods.selectedSkuPrice = this.getSkuPrice(this.selectedSku.id);
      // buyGoods['num'] = this.selectedNum;
      // this.addShopCardGoods(buyGoods);
      // Toast(this.$t('tips.cart_success'));
    },
    buyNow() {
      if (this.selectedSku.id == undefined || this.selectedSku.id == null) {
        // Toast('請選擇一种規格');
        this.show = true;
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = this.selectedSku.id;
      buyGoods.selectedSkuPrice = this.getSkuPrice(this.selectedSku.id);
      buyGoods.selectedSkuName = this.selectedSku.name;
      buyGoods['num'] = this.selectedNum;
      let goodsList = [buyGoods];
      // console.log('====goodsList=', goodsList);
      this.refreshOrderGoods(goodsList);
      this.$router.push('/orderStep3');
    },
    stepperChange(e) {
      // console.log('====goodsList=', e);
      this.selectedNum = e;
    },
    skuSelected(e) {
      // console.log('====goodsList=', e);
      if (this.selectedNum == 0) {
        this.selectedNum = 1;
      }

      this.selectedSku = e.skuValue;
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  // beforeRouteUpdate(to, from, next) {
  // },
  // beforeRouteLeave(to, from, next) {
  //   next();
  // },
};
</script>

<style lang="scss" scoped='scoped'>
.goods {
  padding-bottom: 50px;
  .my-swipe{
    height: 15rem;
  }
  .header_img {
    width: 100%;
    height: 15rem;
  }
  .van-image__img {
    height: inherit;
  }
  &-title {
    font-size: 16px;
  }
  &-brief {
    font-size: 13px;
    color: #d85757;
  }
  &-price {
    color: #f44;
    font-size: 18px;
    .source{
      font-size: 10px;
      color: #868788;
      text-decoration:line-through;
      padding-left: 10px;
    }
  }
  .sku_line_item {
    display: flex;
    color: #7c7d7d;
    font-size: 12px;
    justify-content: space-between;
  }
  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }
  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }
  &-tag {
    margin-left: 5px;
  }
}
.border{
    border-top: 0.2rem solid #f8f8f8;
    border-bottom: 0.2rem solid #f8f8f8;
    color: #7c7d7d;
}
.color{
  color: #7c7d7d;
}
.sheet{
    // height: 80%;
    // overflow-y: hidden;
    z-index: 2004;
    // padding-bottom: 2rem;
    .title{
      width: 90%;
      padding: 2% 5%;
      border-bottom: 0.2rem solid #f5f5f5;
      span{
        font-size: 0.65rem;
        font-weight: 550;
      }
      // .name{
      //   padding-left: 0.2rem;
      // }
      .money{
        color: #ca2e2e;
      }
      .orign{
        font-size: 0.5rem;
        color: #868788;
        text-decoration:line-through;
        padding-left: 0.5rem;
      }
    }
    .cont{
      height: 60%;
      overflow-y: scroll;
      padding-bottom: 25%;
    }
}

.combo{
  padding-bottom: 15%;
  .goodSheet{
    width: 90%;
    margin: 2% 5%;
    .van-col{
        margin: 0 2%;
        line-height: 1.1rem;
    }
    .van-tag{
      margin: 0.2rem 0.1rem;
      height: 1rem;
    }
  }
  .grid{
        width: 90%;
        margin-left: 5%;
        // margin-top: 0.5rem;
        .grid_item{
          // margin:0.2rem 0.2rem 0.2rem 0;
          .van_img {
              width: 1.8rem;
              height: 1.8rem;
              padding: 0.2rem;
              border: 0.05rem solid #e4e4e4;
              margin: 0.2rem;
          }
        }
        .select{
          .van_img {
              width: 1.8rem;
              height: 1.8rem;
              padding: 0.2rem;
              border: 0.05rem solid #e4e4e4;
              margin: 0.2rem;
              border: 0.05rem solid  #ee0a24;
          }
        }
    }

}
.comboSelect{
    width: 90%;
    padding: 2% 3%;
    margin: 1%;
    border-bottom: 0.01rem solid #e2dfdf;
  .name{
    line-height: 1rem;
  }
  .list{
    .van-tag{
      margin: 0.2rem 0.1rem;
      height: 1rem;
    }
    .select{
          color: #ca2e2e;
    }
  }
}
.skuName{
    font-size: 0.65rem;
    font-weight: 550;
    color: black;
}
.tag{
  margin: 0.2rem 0.5rem; 
  height: 1rem;
}
.nav_title{
  .van-nav-bar__left{
    .van-icon{
      color: #6f6f73;
    }
    .van-nav-bar__text{
      color: #6f6f73;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/GoodsDetail.vue